import { getAxiosInstance } from "../../../../api";

export const PrintCertificate = async (body) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.post(
      `/printing-report/old-certificate/create-certificate`,
      body,
    );
    return res;
  } catch (error) {
    return error.response.data;
  }
};

export const uploadKalyanCertificate = async (body) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.post(`/kalyan-certificates`, body);
    return res;
  } catch (error) {
    return error.response.data;
  }
};
